import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { TagLink } from '#components/patterns/entity-links/tag-link/TagLink.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import type { TagName } from '#dn-types/host.ts';
import { DeleteTagDialog } from '../delete/DeleteTagDialog.tsx';

type Props = {
  tagName: TagName;
};

export function TagActionMenu({ tagName }: Props) {
  const [tagBeingDeletedName, setTagBeingDeletedName] = useState<TagName | null>();

  return (
    <>
      <MeatballMenu>
        <MenuItem render={<TagLink tagName={tagName} />}>Edit</MenuItem>
        <MenuItem render={<Link to={`/tags/add?duplicateFrom=${encodeURIComponent(tagName)}`} />}>Duplicate</MenuItem>
        <MenuItem onClick={() => setTagBeingDeletedName(tagName)}>Delete</MenuItem>
      </MeatballMenu>
      {tagBeingDeletedName ?
        <DeleteTagDialog
          tagName={tagBeingDeletedName}
          onCancel={() => setTagBeingDeletedName(null)}
          onDelete={() => setTagBeingDeletedName(null)}
        />
      : null}
    </>
  );
}
